import { AuthService } from '@uw/core/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, NgForm, Validators, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MenuService } from '@uw/themes/services/menu.service';
import { takeUntil } from 'rxjs';
import { BaseComponent } from '@uw/core/base.component';
import { LayoutUtilsService, MessageType } from '@uw/shared/services/layout-utils.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatInput, MatError } from '@angular/material/input';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
    selector: 'uw-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    imports: [ReactiveFormsModule, MatInput, MatError, TranslateModule]
})
export class ResetPasswordComponent  implements OnInit {

  resetFormGrp!: UntypedFormGroup;
  matcher = new MyErrorStateMatcher();
  errorMessage!: string;
  resetToken:string = '';
  email: string = '';
  buttonLoading = false;
  cguid: string = '';

  constructor(private fb: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private menuService: MenuService,
    ) {
   // super();
    this.menuService.showDonarSubMenu(true);
    this.createForm();
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams
    .subscribe((queryParams) => {
      if (queryParams.resetToken) {
        this.resetToken = encodeURIComponent(queryParams.resetToken);
        this.email = queryParams.email ? queryParams.email.trim(): null;
        this.cguid = queryParams.cguid;
        if (this.email && this.email.includes('')){
          this.email= this.email.replace(' ','+');
        }
        this.verifyToken();
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  verifyToken(){
    this.errorMessage = '';
    this.verifyTokenEndpoint().subscribe(data=> {
        return;
    }, err=>{
      this.errorMessage = this.translateService.instant('messages.password_update_failed');
      this.showError('messages.invalid_token');
      this.router.navigate(['login']);
    });
  }

  createForm(){
    this.resetFormGrp = this.fb.group({
      password: new UntypedFormControl(null, [Validators.required, Validators.pattern("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z0-9$@$!%*?&].{8,}")]),
      confirmPassword: [null,[Validators.required]]
    });
  }

  onNoClick(): void {
    //this.dialogRef.close();
  }

  setPassword(): void {
    this.errorMessage = '';
    this.resetPasswordEndpoint().subscribe(data=> {
        this.showSuccess('messages.password_updated');
        this.router.navigate(['/login'],{ queryParams: {cguid: this.cguid}});

    }, err=>{
      this.errorMessage = this.translateService.instant('messages.password_update_failed');
    });
    //this.router.navigate(['/private']);
  }

  showSuccess(message: string) {
    this.layoutUtilsService.showNotification(
      this.translateService.instant(message),
      MessageType.Success
    );
  }

  showError(message: string) {
    this.layoutUtilsService.showNotification(
      this.translateService.instant(message),
      MessageType.Error
    );
  }

  verifyTokenEndpoint(){
    return this.resetToken && this.resetToken.length > 40
        ?  this.authService.verifyToken(this.resetToken, this.email)
        : this.authService.verifyNewToken(this.resetToken, this.email);
  }

  resetPasswordEndpoint(){
    return this.resetToken && this.resetToken.length > 40
        ? this.authService.setPassword(this.resetFormGrp.value, this.resetToken, this.email)
        : this.authService.resetPasswordPasswordGuid(this.resetFormGrp.value, this.resetToken, this.email);
  }

  showPassword(passwordControl: any) {
    if (passwordControl.type === "password") {
      passwordControl.type = "text";
    } else {
      passwordControl.type = "password";
    }
  }

}

